export const PRIVATE_REALTIME_CHANNEL_CONFIG = {
  private: true,
} as const;
